/**
 * Deterministically hashes a UUID string down to an unsigned 32-bit integer, by XOR-folding
 * its four 32-bit hex chunks together. Used for Forethought's data-ft-account-Id widget
 * attribute, which requires an integer context variable, while the rest of the app only ever
 * exposes admin identities as UUIDs.
 */
export function uuidToInt (uuid: string): number {
  const hex = uuid.replace(/-/g, '')
  let result = 0
  for (let i = 0; i < 32; i += 8) {
    result ^= parseInt(hex.slice(i, i + 8), 16)
  }
  return result >>> 0
}
